document.addEventListener("DOMContentLoaded", () => {
  const stickyWrapper = document.querySelector(".sticky-atc");
  if (!stickyWrapper) return;

  const initStickyClone = () => {
    const nativeBtn = document.querySelector(
      "product-form .product-form__submit"
    );
    const nativePrice = document.querySelector("product-info .price");

    if (!nativeBtn || !nativePrice) return;

    // ⭐ clear previous clones
    stickyWrapper.innerHTML = "";

    /* ==============================
       PRICE CLONE
    ============================== */
    const priceClone = nativePrice.cloneNode(true);
    priceClone.classList.add("sticky-atc__price");

    /* ==============================
       BUTTON CLONE
    ============================== */
    const btnClone = nativeBtn.cloneNode(true);
    btnClone.id = "stickyAddToCart";

    // clicking clone triggers native button
    btnClone.addEventListener("click", (e) => {
      e.preventDefault();
      nativeBtn.click();
    });

    // ⭐ sync state automatically
    const syncState = () => {
      btnClone.disabled = nativeBtn.disabled;
      btnClone.className = nativeBtn.className;
      btnClone.innerHTML = nativeBtn.innerHTML;
    };

    syncState();

    const btnObserver = new MutationObserver(syncState);
    btnObserver.observe(nativeBtn, {
      attributes: true,
      childList: true,
      subtree: true
    });

    /* ==============================
       APPEND
    ============================== */
    stickyWrapper.append(priceClone, btnClone);

    // reveal sticky after cloning
    stickyWrapper.classList.add("is-ready");
  };

  initStickyClone();

  /* ==============================
     Sense re-renders product-info
  ============================== */
  const productInfo = document.querySelector("product-info");

  if (productInfo) {
    const observer = new MutationObserver(() => {
      setTimeout(initStickyClone, 50);
    });

    observer.observe(productInfo, {
      childList: true,
      subtree: true
    });
  }
});